export default {
	reset (state) {
		Object.assign(state, {
			authentication: {
				token: null,
				user: null,
				loggedIn: false
			},
			settings: {
				darkMode: false
			},
			modal: {
				open: false
			},
			plannings: [],
			social: {
				friends: [],
				friendRequests: []
			}
		})
	},
	login (state, payload) {
		state.authentication.token = payload.token
		state.authentication.user = payload.user
		state.authentication.loggedIn = true
	},
	logout (state) {
		state.authentication.token = null
		state.authentication.user = null
		state.authentication.loggedIn = false
	},
	setUser (state, payload) {
		state.authentication.user.username = payload.user.username
		state.authentication.user.first_name = payload.user.first_name
		state.authentication.user.last_name = payload.user.last_name
		// state.authentication.user.email = payload.user.email
		state.authentication.user.School = payload.user.School
		state.authentication.user.Program = payload.user.Program
	},
	// Settings
	toggleDarkMode (state) {
		state.settings.darkMode = !state.settings.darkMode
	},
	toggleWeekView (state) {
		state.settings.weekView = (state.settings.weekView === 'byDay') ? 'byPlanning' : 'byDay'
	},
	// Modal
	openModal (state, content) {
		state.modal.open = true
		if (content) state.modal.content = content
	},
	closeModal (state) {
		state.modal.open = false
		state.modal.content = null
	},
	setModalContent (state, payload) {
		state.modal.content = payload
	},
	// Plannings
	setPlannings (state, payload) {
		var plannings = payload
		if (plannings) {
			if (plannings.length > 0) {
				// Add topic index to every task
				plannings.forEach(function (planning) {
					planning.Tasks.forEach(function (task, index) {
						const topicIndex = planning.Topics.findIndex(topic => topic.id === task.Info.TopicId)
						task.topicIndex = topicIndex
					})
				})
			} else plannings = null
		}
		state.plannings = plannings
	},
	toggleTask (state, payload) {
		if (!payload.parentIndex && payload.parentIndex !== 0) {
			state.plannings[payload.planningIndex].Tasks[payload.taskIndex].Info.done = payload.done
		} else {
			state.plannings[payload.planningIndex].Tasks[payload.parentIndex].ChildTasks[payload.taskIndex].Info.done = payload.done
		}
	},
	/* Socials */
	setFriends (state, payload) {
		var friends = payload
		if (friends) {
			if (friends.length > 0) {
				var friendNames = []
				var validFriends = []
				friends.forEach(function (friend) {
					if (friend.User) {
						friendNames.push(friend.User.username)
						validFriends.push(friend)
					}
				})
			}
		}
		state.social.friends = validFriends
		state.social.friendNames = friendNames
	},
	setFriendRequests (state, payload) {
		state.social.friendRequests = payload
	}
}
